import { useEffect, useState } from 'react';
import { C } from '../utils/constants';

// Mobile breakpoint: 480px keeps the scale inside the day-journal card on
// typical phone widths (~360–414px) without affecting tablet/desktop.
const MOBILE_BREAKPOINT = 480;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' && window.innerWidth < MOBILE_BREAKPOINT
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return isMobile;
};

export const ScaleQuestion = ({ label, value, onChange }) => {
  const isMobile = useIsMobile();

  // Desktop totals: 56 + 6*40 + 7*8 + 36 = 388px. On a ~360px viewport with
  // card padding this overflowed and clipped the "Fully" label. Shrinking
  // the buttons + gap on mobile brings the row inside the card.
  const btnSize = isMobile ? 32 : 40;
  const rowGap = isMobile ? 4 : 8;
  const labelMinLeft = isMobile ? 48 : 56;
  const labelMinRight = isMobile ? 30 : 36;

  return (
    <div style={{ marginBottom: 20 }}>
      <p style={{
        fontSize: '0.9rem',
        color: C.text,
        fontWeight: 600,
        marginBottom: 10,
        lineHeight: 1.4,
      }}>
        {label}
      </p>

      <div style={{ display: 'flex', alignItems: 'center', gap: rowGap }}>
        <span style={{
          fontSize: '0.72rem',
          color: C.terracotta,
          whiteSpace: 'nowrap',
          minWidth: labelMinLeft,
        }}>
          Not at all
        </span>

        {[0, 1, 2, 3, 4, 5].map((num) => {
          const isSelected = value === num;
          return (
            <button
              key={num}
              onClick={() => onChange(num)}
              style={{
                width: btnSize,
                height: btnSize,
                borderRadius: '50%',
                border: `1.5px solid ${isSelected ? C.gold : C.border}`,
                background: isSelected
                  ? `linear-gradient(135deg, ${C.amber}, ${C.gold})`
                  : '#fff',
                color: isSelected ? '#fff' : C.brown,
                fontFamily: "'Nunito', sans-serif",
                fontSize: isMobile ? '0.8rem' : '0.9rem',
                fontWeight: isSelected ? 700 : 500,
                cursor: 'pointer',
                transition: 'all 0.18s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: isSelected
                  ? `0 2px 10px rgba(245,166,35,0.5)`
                  : 'none',
                flexShrink: 0,
                padding: 0,
              }}
              onMouseEnter={e => {
                if (!isSelected) {
                  e.currentTarget.style.background = C.veryLightBrown;
                  e.currentTarget.style.borderColor = C.brown;
                }
              }}
              onMouseLeave={e => {
                if (!isSelected) {
                  e.currentTarget.style.background = '#fff';
                  e.currentTarget.style.borderColor = C.border;
                }
              }}
            >
              {num}
            </button>
          );
        })}

        <span style={{
          fontSize: '0.72rem',
          color: C.terracotta,
          whiteSpace: 'nowrap',
          minWidth: labelMinRight,
        }}>
          Fully
        </span>
      </div>
    </div>
  );
};
